import {
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

import { RETAIN_VALUE } from '@/constants';
import { ArrowDropDown } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { ValueMapping } from './MapValues';
import { ColumnBox, FieldRow, InputBox, RiskAccordian, StyledSelect } from './styles';

export const MappingSection = ({
  title,
  mappings,
  validValues,
  onChange,
}: {
  title: string;
  mappings: ValueMapping[];
  validValues: string[];
  onChange: (index: number, value: string) => void;
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean | undefined>(false);

  useEffect(() => {
    if (mappings.length > 0 && mappings.some((mapping) => mapping.systemValue === '')) {
      setIsExpanded(true);
    }
  }, [mappings]);

  if (mappings.length === 0) return null;

  return (
    <RiskAccordian
      elevation={0}
      slotProps={{
        transition: {
          timeout: 300,
        },
      }}
      disableGutters
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      <AccordionSummary id="panel-header" aria-controls="panel-content">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          padding="2.4rem"
        >
          <Typography variant="h4" fontWeight={500} color="primary.600">
            {title}
          </Typography>
          <IconButton disableRipple onClick={() => setIsExpanded(!isExpanded)} sx={{ padding: 0 }}>
            <ArrowDropDown
              sx={{
                fontSize: '1.6rem',
                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }}
            />
          </IconButton>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box padding="2.4rem" paddingTop={0} gap="1.6rem">
          <Grid container marginBottom="1.6rem" spacing={2}>
            <Grid size={6}>
              <Typography fontWeight={500} color="primary.600">
                Your Value
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography fontWeight={500} color="primary.600">
                System Value
              </Typography>
            </Grid>
          </Grid>
          <Stack gap="1.6rem">
            {mappings.map((mapping, index) => (
              <FieldRow key={index}>
                <InputBox>
                  <ColumnBox>
                    <Typography variant="caption">{mapping.userValue}</Typography>
                  </ColumnBox>
                </InputBox>
                <InputBox>
                  <FormControl fullWidth size="small" error={!mapping.systemValue}>
                    <StyledSelect
                      value={mapping.systemValue}
                      onChange={(e) => onChange(index, e.target.value as string)}
                    >
                      <MenuItem value="">-- Select --</MenuItem>
                      <MenuItem value={RETAIN_VALUE}>Retain Original</MenuItem>
                      {validValues.map((value) => (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                  </FormControl>
                </InputBox>
              </FieldRow>
            ))}
          </Stack>
        </Box>
      </AccordionDetails>
    </RiskAccordian>
  );
};
